module.exports = __webpack_public_path__ + "static/media/ico_terminal.9c19cf32.svg";